import ElectricityHero from 'assets/images/psp/PSPHero/electricity-hero.webp';

import ElectricityVideo1 from 'assets/images/psp/FeaturedContentImages/electricity-video-content-1.png';
import ElectricityVideo2 from 'assets/images/psp/FeaturedContentImages/electricity-video-content-2.png';

import storage5x5 from 'assets/images/icons/psp/electricity/5x5.png';
import storage5x10 from 'assets/images/icons/psp/electricity/5x10.png';
import storage10x10 from 'assets/images/icons/psp/electricity/10x10.png';
import storage10x15 from 'assets/images/icons/psp/electricity/10x15.png';
import storage10x20 from 'assets/images/icons/psp/electricity/10x20.png';
import storage10x30 from 'assets/images/icons/psp/electricity/10x30.png';

import useCaseElectronics from 'assets/images/icons/psp/electricity/electronics.svg';
import useCaseTools from 'assets/images/icons/psp/electricity/tools.svg';
import useCaseCraft from 'assets/images/icons/psp/electricity/crafts.svg';
import useCaseDecor from 'assets/images/icons/psp/electricity/decorations.svg';
import useCaseDocuments from 'assets/images/icons/psp/electricity/documents.svg';
import useCaseExercise from 'assets/images/icons/psp/electricity/exercise.svg';
import useCaseInventory from 'assets/images/icons/psp/electricity/business-inventory.svg';
import useCaseWine from 'assets/images/icons/psp/electricity/wine.svg';

import featureElectrical from 'assets/images/icons/psp/electricity/electrical-setup.svg';
import featureAccess from 'assets/images/icons/psp/electricity/extended-access.svg';
import featureDriveUp from 'assets/images/icons/psp/electricity/driveup-access.svg';
import featureSecurity from 'assets/images/icons/psp/electricity/security.svg';
import featureCustomerService from 'assets/images/icons/psp/electricity/customer-service.svg';

import compareHome from 'assets/images/icons/psp/electricity/home-storage.svg';
import compareStorage from 'assets/images/icons/psp/electricity/storage-units.svg';

import Related1 from 'assets/images/psp/FeaturedContentImages/electric-related-1.webp';
import Related2 from 'assets/images/psp/FeaturedContentImages/electric-related-2.webp';
import Related3 from 'assets/images/psp/FeaturedContentImages/electric-related-3.jpg';
import Related4 from 'assets/images/psp/FeaturedContentImages/electric-related-4.jpg';

import { storageCategories } from 'pages/PSPPage/utils/getPSPLinks';

const electricityPricingComparison = {
	title: 'Pricing Comparison: Units With vs. Without Electricity',
	description: '',
	cardData: [
		{
			imageSrc: storage5x5,
			title: '5x5',
			content:
				'**Standard Unit Pricing:** $45-65/month\n\n**Units with Electricity Pricing:** $55-75/month',
			contentAlign: 'text-left',
		},
		{
			imageSrc: storage5x10,
			title: '5x10',
			content:
				'**Standard Unit Pricing:** $65-85/month\n\n**Units with Electricity Pricing:** $80-100/month',
			contentAlign: 'text-left',
		},
		{
			imageSrc: storage10x10,
			title: '10x10',
			content:
				'**Standard Unit Pricing:** $85-120/month\n\n**Units with Electricity Pricing:** $105-140/month',
			contentAlign: 'text-left',
		},
		{
			imageSrc: storage10x15,
			title: '10x15',
			content:
				'**Standard Unit Pricing:** $120-160/month\n\n**Units with Electricity Pricing:** $145-185/month',
			contentAlign: 'text-left',
		},
		{
			imageSrc: storage10x20,
			title: '10x20',
			content:
				'**Standard Unit Pricing:** $160-200/month\n\n**Units with Electricity Pricing:** $190-235/month',
			contentAlign: 'text-left',
		},
		{
			imageSrc: storage10x30,
			title: '10x30',
			content:
				'**Standard Unit Pricing:** $200-260/month\n\n**Units with Electricity Pricing:** $240-305/month',
			contentAlign: 'text-left',
		},
	],
};

const electricityUseCases = {
	title: 'Use Cases for Units with Electricity',
	description: '',
	cardData: [
		{
			imageSrc: useCaseElectronics,
			title: 'Electronics & Appliances',
			content:
				'Mini fridges, dehumidifiers, fans, and small appliances that need consistent power. Perfect for keeping seasonal items like holiday lights tested and ready to use.',
		},
		{
			imageSrc: useCaseTools,
			title: 'Power Tools & Equipment',
			content:
				'Keep battery chargers plugged in, run ventilation for workshop projects, and maintain tools in optimal condition with climate control.',
		},
		{
			imageSrc: useCaseCraft,
			title: 'Craft & Hobby Supplies',
			content:
				'Power sewing machines, 3D printers, pottery wheels, or other creative equipment. Good lighting makes organizing supplies so much easier!',
		},
		{
			imageSrc: useCaseDecor,
			title: 'Seasonal Decorations',
			content:
				'Keep animated decorations working, maintain light-up displays, and store items that need to stay dust-free with powered air filtration.',
		},
		{
			imageSrc: useCaseDocuments,
			title: 'Important Documents',
			content:
				'Power document scanners and keep filing systems accessible with adequate lighting.',
		},
		{
			imageSrc: useCaseExercise,
			title: 'Exercise Equipment',
			content:
				'Keep treadmills, exercise bikes, and other powered fitness equipment maintained and ready to use in your storage gym setup.',
		},
		{
			imageSrc: useCaseInventory,
			title: 'Business Inventory',
			content:
				'Power point-of-sale systems, maintain refrigerated products, and keep inventory organized under bright lighting for easy access.',
		},
		{
			imageSrc: useCaseWine,
			title: 'Wine & Collectibles',
			content:
				'Run specialized cooling units, maintain optimal storage conditions with climate control, and keep valuable collections visible under proper lighting.',
		},
	],
};

const electricityWhatToLookFor = {
	title: 'What to Look for in Storage Units with Power Outlets',
	description: '',
	cardData: [
		{
			imageSrc: featureElectrical,
			title: 'Electrical Setup',
			content:
				'More outlets = more flexibility for your projects and equipment',
		},
		{
			imageSrc: featureAccess,
			title: 'Extended Access Hours',
			content: 'Work on projects when it fits your schedule',
		},
		{
			imageSrc: featureDriveUp,
			title: 'Drive Up Access',
			content: 'Allow you to move heavy items much more easily',
		},
		{
			imageSrc: featureSecurity,
			title: 'Security',
			content:
				'Better lighting + cameras = safer for evening visits & protect your items',
		},
		{
			imageSrc: featureCustomerService,
			title: 'Customer Service',
			content:
				"Someone's there when you need help with electrical issues",
		},
	],
};

const electricityCostTabs = {
	title: 'The Real Cost of Home Storage vs. Storage Units with Electricity',
	cardData: [
		{
			title: 'Home Storage',
			content:
				'**Lost living space:** 100 sq ft of home space = $150-300/month in opportunity cost\n\n' +
				'**Higher utility bills:** Heating/cooling unused storage areas = $25-50/month extra\n\n' +
				'**Organization time:** Searching through cluttered areas = 2-3 hours monthly\n\n' +
				'**Potential damage:** Risk of replacing batteries or items needing maintenance charging\n\n' +
				'\n\n' +
				'**Total hidden cost:** $200-375/month',
			imageSrc: compareHome,
			contentAlign: 'text-left',
		},
		{
			title: 'Storage Units',
			content:
				'**Dedicated organized space:** $80-140/month for powered units\n\n' +
				'**No extra utilities:** Lighting + basic power included\n\n' +
				'**Time savings:** Good lighting = find items fast\n\n' +
				'**Protection:** Controlled environment preserves belongings\n\n' +
				'\n\n' +
				'**Total cost upfront:** $80-140/month',
			imageSrc: compareStorage,
			contentAlign: 'text-left',
		},
	],
};

const reviews = [
	{
		title: 'Took only 20 minutes at the most to …',
		stars: 5,
		text: 'Took only 20 minutes at the most to walk in, do paperwork and get my storage. I believe his name was JJ. He was a huge help very polite and gave us a good deal. Recommend this place to everyone. On top of all that our unit has electricity. Did not expect that at all!!',
		link: 'https://www.trustpilot.com/reviews/58f8ae472ecbfc077c458df5',
		customerName: 'Bridgett',
		date: 'April 20, 2017',
	},
	{
		title: 'Great experience',
		stars: 5,
		text: 'Easy to use, really like being able to filter by available features, since I needed a unit with electricity.',
		link: 'https://www.trustpilot.com/reviews/548dc96f0000640002bc6e5d',
		customerName: 'Tom D.',
		date: 'December 14, 2014',
	},
	{
		title: 'Very Happy With The Facility & Staff',
		stars: 5,
		text: 'Nice clean new unit. It will fit my needs perfectly. $30-70 less per month than other facilities in the area. Plus my unit has power at no extra cost. I am overall pleased.',
		link: 'https://www.trustpilot.com/reviews/5e8b48cc086b6409bc7e6a48',
		customerName: 'Nate Kuck',
		date: 'April 6, 2020',
	},
	{
		title: 'Very fast and easy registration…',
		stars: 5,
		text: 'Very fast and easy registration process. My unit was clean and dry. Rental fees the best in area. No long term commitment. Light and power in unit. Highly recommend',
		link: 'https://www.trustpilot.com/reviews/5ec5b3f725e5d209b8f08339',
		customerName: 'Judy DeVries-Eppinga',
		date: 'May 20, 2020',
	},
];

const faqs = [
	{
		question: 'Do storage units have lights inside?',
		answer: 'Most storage units with power include interior lighting, typically LED fixtures controlled by wall switches. Standard units may only have hallway lighting.\n\n If you plan to spend time organizing or working in your unit, powered units with interior lights are definitely worth the upgrade.',
	},
	{
		question: 'What can I plug into storage unit outlets?',
		answer: 'You can power small appliances, electronics, power tools, battery chargers, fans, dehumidifiers, and lighting equipment. Most units provide standard 110V outlets with 15-20A capacity. Check with your facility about any restrictions on high-powered equipment.',
	},
	{
		question: 'How much more do storage units with electricity cost?',
		answer: 'Storage with electricity typically costs $10-40 more per month depending on unit size. The convenience of having power and proper lighting often makes this small premium worthwhile, especially for frequently accessed units.',
	},
	{
		question:
			'Do storage units with electricity come with climate control?',
		answer: "Many facilities offer units with both electricity and climate control, but they're separate features. If you need both power and temperature control, look for combination units or ask about upgrading to get the best protection for your belongings.",
	},
	{
		question: 'Can I work on projects in my storage unit?',
		answer: 'Most facilities allow reasonable project work during business hours, but check the specific rules. Storage units with power are popular for crafting, woodworking, and organizing projects.',
	},
	{
		question:
			'What should I look for when choosing a storage unit with electricity?',
		answer: 'Consider outlet placement and quantity, interior lighting quality, ventilation, security features, and access hours. If you plan to use power tools or equipment, ensure the electrical capacity meets your needs and ask about any usage restrictions.',
	},
];

export const ElectricityContent = {
	type: 'Electricity',
	reviews: reviews,
	sections: [
		{
			title: 'Electricity Storage Hero',
			background: 'default',
			modules: [
				{
					type: 'hero',
					id: 'electricity-storage-hero',
					props: {
						content: {
							title: 'Find Affordable Self Storage with Electricity',
							description:
								'Need to store items that require power or want to work on projects in your storage space?\n\n' +
								"[Storage units with electricity](https://www.selfstorage.com/blog/storage-units-with-electricity/) provide reliable electrical outlets and interior lighting. They’re perfect for storing electronics, power tools, appliances, and seasonal decorations that need to stay plugged in. Whether you're [downsizing](https://www.selfstorage.com/blog/how-storage-reduces-cost-of-living/), organizing a craft room, or need a workshop space, self storage with electricity gives you the flexibility to keep things powered up and easily accessible.\n\n" +
								'**SelfStorage.com** makes it simple to find and reserve the perfect storage unit with electricity near you that fits your needs and budget.',
							image: ElectricityHero,
							CTAtext: 'Find Electricity Self Storage',
						},
					},
				},
			],
		},
		{
			title: 'electricity video content 1',
			noPaddingBottom: true,
			background: 'blueGradient',
			modules: [
				{
					type: 'video',
					title: 'Why Storage Units with Power is a Gamechanger',
					props: {
						content: {
							title: 'Why Storage Units with Power is a Gamechanger',
							description:
								'### Personal Storage \n\n' +
								"Having electricity in your storage unit isn't just about keeping the lights on—it's about transforming your storage space into a functional extension of your home.\n\n From seasonal decoration prep stations to craft supply organization centers, powered units let you work efficiently in your space.",
							imageSrc: ElectricityVideo1,
							videoSrc: '',
							suffixText:
								'Without a well-lit facility, it will be difficult to find your way to and from your unit after hours, and paying extra for lighting can help your peace of mind by making it easier for security cameras to catch any threats.\n\n Powered units are usually [climate controlled](https://www.selfstorage.com/blog/what-is-climate-controlled-storage-2/) as well, adding even more protection for your items.',
						},
					},
				},
			],
		},
		{
			title: 'electricity video content 2',
			noPaddingBottom: false,
			background: 'blueGradient',
			modules: [
				{
					type: 'video',
					title: 'Business Storage',
					props: {
						content: {
							title: 'How to Use Self Storage with Electricity for Business',
							description:
								'Storage units with power have become the secret weapon for entrepreneurs who need [professional storage solutions](https://www.selfstorage.com/blog/small-business-inventory-storage-2/) without the overhead of commercial space.',
							imageSrc: ElectricityVideo2,
							videoSrc: '',
							suffixText:
								'From e-commerce sellers who need climate controlled product storage to crafters managing seasonal inventory, having electricity means you can maintain point-of-sale systems, keep products properly stored with dehumidifiers, and even create a mini-fulfillment center with adequate lighting for packaging orders.',
						},
					},
				},
			],
		},
		{
			title: 'Electricity Storage Pricing Comparison',
			background: 'gray',
			modules: [
				{
					type: 'cardStrip',
					props: {
						heading: electricityPricingComparison.title,
						description: electricityPricingComparison.description,
						content:
							'Prices vary by location and facility amenities',
						cardData: electricityPricingComparison.cardData,
					},
				},
			],
		},
		{
			title: 'Electricity Use Cases',
			background: 'white',
			modules: [
				{
					type: 'cardStrip',
					props: {
						heading: electricityUseCases.title,
						description: electricityUseCases.description,
						cardData: electricityUseCases.cardData,
						content: '',
					},
				},
			],
		},
		{
			title: 'What to Look For',
			background: 'gray',
			modules: [
				{
					type: 'cardStrip',
					props: {
						heading: electricityWhatToLookFor.title,
						description: electricityWhatToLookFor.description,
						cardData: electricityWhatToLookFor.cardData,
						content:
							"Pro tip: Always ask to see the unit's electrical setup before signing, as outlet placements can make or break your storage experience!",
					},
				},
			],
		},
		{
			title: 'Home vs Storage Cost Comparison',
			background: 'white',
			modules: [
				{
					type: 'cardStrip',
					props: {
						heading: electricityCostTabs.title,
						description: electricityCostTabs.description,
						cardData: electricityCostTabs.cardData,
						content: '',
					},
				},
			],
		},
		{
			title: 'Reviews Section',
			background: 'lighterBlue',
			modules: [
				{
					type: 'reviews',
					props: {
						reviewsData: {
							reviews,
							headerTitle: 'Storage Units with Electricity: ',
						},
					},
				},
			],
		},
		{
			title: 'Faqs Section',
			background: 'white',
			modules: [
				{
					type: 'faqs',
					props: {
						content: {
							header: 'Storage Units with Electricity FAQs',
							faqs,
						},
					},
				},
			],
		},
		{
			title: 'related content',
			background: 'darkBlue',
			modules: [
				{
					type: 'featuredContent',
					props: {
						data: {
							heading:
								'Learn All About Self Storage with Electricity',
							type: 'electricityRelatedContent',
							id: 'electricity-related-content',
							data: {
								unitCards: [
									{
										title: 'Storage Tips',
										date: 'July 25, 2025',
										image: Related1,
										url: 'https://www.selfstorage.com/blog/storage-units-with-electricity/',
										content:
											'Do Storage Units Have Electricity?',
									},
									{
										title: 'Storage Tips',
										date: 'May 20, 2025',
										image: Related2,
										url: 'https://www.selfstorage.com/blog/business-and-commercial-storage-units-2/',
										content:
											'Self-Storage Units: Business and Commercial Storage Spaces',
									},
									{
										title: 'Storage Tips',
										date: 'August 26, 2025',
										image: Related3,
										url: 'https://www.selfstorage.com/blog/small-business-inventory-storage-2/',
										content:
											'Elevating Efficiency: Small Business Inventory Management with Self-Storage Solutions',
									},
									{
										title: 'Storage Tips',
										date: 'May 29, 2025',
										image: Related4,
										url: 'https://www.selfstorage.com/blog/how-to-create-a-self-storage-inventory/',
										content:
											'How to Create a Self-Storage Inventory That Works',
									},
								],
							},
						},
					},
				},
			],
		},
		{
			title: 'Links to other PSPs',
			background: 'lighterBlue',
			modules: [
				{
					type: 'links',
					props: {
						heading: {
							headingName: 'More Ways to Store',
						},
						linksList: storageCategories.electricityStorage,
					},
				},
			],
		},
		{
			title: 'nearby cities',
			modules: [
				{ type: 'storageNearYou', props: { type: 'Electricity' } },
			], // TODO: check if this format is correct
		},
	],
};
